import type { DeckEmbed } from '@/entities/embed'
import type { EditDeck } from './useEditDeck'

type DeckEmbedSearch = {
  readonly count: number
  readonly next: string | null
  readonly previous: string | null
  readonly results: DeckEmbed[]
}

export interface UseEmbedNavigation {
  goToEmbeds(): Promise<void>
}

export function useEmbedNavigation({ deck: { company_id, title, id } }: { deck: EditDeck }): UseEmbedNavigation {
  async function goToEmbeds() {
    const { count, results } = await $fetch<DeckEmbedSearch>(
      `v2/companies/${company_id}/embed/decks?deck_id=${id}`,
      useFetchSharedOptions(),
    )

    if (count === 0) {
      _goToCreatePage()
    } else if (count === 1) {
      _goToEditPage(results[0])
    } else {
      _goToSearchPage(title)
    }
  }

  function _goToCreatePage() {
    window.open(`/admin/embeds/create?deck_id=${id}`, '_blank')
  }

  function _goToEditPage({ id }: DeckEmbed) {
    window.open(`/admin/embeds/${id}`, '_blank')
  }

  function _goToSearchPage(searchTerm: string) {
    const url = new URL('/admin/embeds', window.location.origin)
    url.searchParams.set('searchTerm', searchTerm)

    window.open(url, '_blank')
  }

  return { goToEmbeds }
}
